import React from 'react'

export const Switch = () => <path d='M1 16L11 21L21 16M1 11L11 16L21 11M11 1L1 6L11 11L21 6L11 1Z' />
